import { MUIDataTableOptions } from "mui-datatables";

export const createTableScrollHandler = (tableRef: React.RefObject<HTMLDivElement>, customOptions?: MUIDataTableOptions) => {
  return (currentPage: number) => {
    if (tableRef.current) {
        tableRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    customOptions?.onChangePage?.(currentPage);
  };
};